@if (showProjectModal) {
  <div id="project_modal" class="pa-modal" (click)="closeProjectModal($event)">
    <!-- Modal content -->
    <div class="modal-content">
      <span id="project_modal_close_button" class="close" (click)="closeProjectModal($event)">&times;</span>
      <table id="project_table">
        <thead>
          <tr>
            <th class="centered_text">Projekt: {{ modalProject.project_name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <label style="margin: 10px; font-size: 1.3rem"> Projektfarbe: </label>
              <input
                style="margin: 10px"
                name="project_color"
                type="color"
                [value]="modalProjectColor"
                (change)="changeModalProjectColor($event)"
              />
            </td>
          </tr>
          <tr>
            <td class="centered_text">
              <button id="update_project_button" (click)="modalProject.updateColorMeta(modalProjectColor)">
                übernehmen
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
}

<div style="position: relative; overflow: visible" class="vertical_flex;">
  <hawk-expand-bar-header [description]="'Kalender'" [isExpanded]="isExpanded" (toggle)="isExpanded = $event">
  </hawk-expand-bar-header>
  <div class="toggle_body" [ngClass]="isExpanded ? 'shown' : ''">
    <table id="table_section_table" class="calendar_table">
      <tbody>
        <tr>
          <td style="border-top: 1px solid black; padding: 0" colspan="2">
            <div id="table_section_tablist" role="tablist" class="calendar_tablist">
              <button
                id="calendar_tab"
                role="tab"
                class="tab bg-base-200 cursor-pointer"
                (click)="deselectCalendarWeek()"
              >
                Kalender
              </button>
              @if (PATimeControl.Instance.selectedCalendarWeekData) {
                <button id="week_tab" role="tab" class="tab bg-base-200 cursor-pointer" (click)="deselectCalendarDay()">
                  KW {{ PATimeControl.Instance.selectedCalendarWeekData.calendar_week.number }}
                </button>
              }
              @if (PATimeControl.Instance.selectedCalendarDay) {
                <button id="day_tab" role="tab" class="tab bg-base-200 cursor-pointer">
                  {{ PATimeControl.Instance.weekDayToGermanName(PATimeControl.Instance.selectedCalendarDay, true) }}
                </button>
              }
            </div>
          </td>
          <td
            class="black_gradient_background"
            style="color: white; border: 1px solid black"
            [attr.rowspan]="
              (showFilteredTechnicians ? (shownTechnicians.length ? shownTechnicians.length + 2 : 0) : 1) +
              preferredTechnicians.length +
              2
            "
            (click)="decrementTimeRange()"
          >
            &#10092;
          </td>
          @if (
            !PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
          ) {
            @for (calendar_week_data of PATimeControl.Instance.shownCalendarWeeksData; track calendar_week_data) {
              <td
                [attr.colspan]="filteredWeekdays.length + 1"
                class="black_gradient_background bold_text"
                style="color: white; border: 1px solid black"
                (click)="selectCalendarWeek(calendar_week_data)"
              >
                KW {{ calendar_week_data.calendar_week.number }}
              </td>
            }
          }
          @if (PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length) {
            <td
              [attr.colspan]="2 * filteredWeekdays.length"
              class="black_gradient_background"
              style="color: white; border: 1px solid black"
            >
              KW {{ PATimeControl.Instance.selectedCalendarWeekData.calendar_week.number }}
            </td>
          }
          @if (PATimeControl.Instance.selectedCalendarWeekData && PATimeControl.Instance.selectedCalendarDay?.length) {
            <td [attr.colspan]="4" class="black_gradient_background" style="color: white; border: 1px solid black">
              KW {{ PATimeControl.Instance.selectedCalendarWeekData.calendar_week.number }}
            </td>
          }
          <td
            class="black_gradient_background"
            style="color: white; border: 1px solid black"
            [attr.rowspan]="
              (showFilteredTechnicians ? (shownTechnicians.length ? shownTechnicians.length + 2 : 0) : 1) +
              preferredTechnicians.length +
              2
            "
            (click)="incrementTimeRange()"
          >
            &#10093;
          </td>
        </tr>

        <tr>
          <td style="border-top: 1px solid black; padding: 0" colspan="2">
            <input
              class="fill_table_cell"
              type="search"
              placeholder="Techniker suchen"
              [(ngModel)]="technicianSearchName"
              (search)="updateShownTechnicians()"
              (keyup)="updateShownTechnicians()"
            />
          </td>
          @if (
            !PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
          ) {
            @for (calendar_week_data of PATimeControl.Instance.shownCalendarWeeksData; track calendar_week_data) {
              @for (week_day of filteredWeekdays; track week_day) {
                <td
                  class="black_gradient_background"
                  style="width: 100px; color: white; border: 1px solid black"
                  (click)="selectCalendarWeekAndDay(calendar_week_data, week_day)"
                >
                  <span style="font-size: 0.75rem; line-height: 0">
                    {{ PATimeControl.Instance.weekDayToGermanName(week_day, true) }}
                    {{
                      PATimeControl.Instance.timestampToDatestring(
                        calendar_week_data.weekdays[week_day].timestamp,
                        false,
                        "."
                      ).slice(0, 5)
                    }}
                    @for (holiday of calendar_week_data.weekdays[week_day].holidays; track holiday) {
                      <span
                        [tooltip]="holiday.tooltip_text"
                        [show-delay]="100"
                        [tooltipClass]="'pa_small_tooltip'"
                        style="line-height: 0"
                      >
                        &#8505;
                      </span>
                    }
                  </span>
                </td>
              }
              <td class="black_background white_text" style="padding: 2px; border: 1px solid black">Std</td>
            }
          }
          @if (PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length) {
            @for (week_day of filteredWeekdays; track week_day) {
              <td
                class="black_gradient_background"
                style="border: 1px solid black"
                (click)="selectCalendarDay(week_day)"
              >
                <span>
                  {{ PATimeControl.Instance.weekDayToGermanName(week_day, true) }}
                  {{
                    PATimeControl.Instance.timestampToDatestring(
                      PATimeControl.Instance.selectedCalendarWeekData.weekdays[week_day].timestamp,
                      false
                    )
                      .split("-")
                      .join(".")
                      .slice(0, 5)
                  }}
                </span>
                @for (
                  holiday of PATimeControl.Instance.selectedCalendarWeekData.weekdays[week_day].holidays;
                  track holiday
                ) {
                  <span
                    [tooltip]="holiday.tooltip_text"
                    [show-delay]="100"
                    [tooltipClass]="'pa_small_tooltip'"
                    class="holiday_warning"
                  >
                    &#8505;
                  </span>
                }
              </td>
              <td class="black_background" style="border: 1px solid black">Min</td>
            }
          }
          @if (PATimeControl.Instance.selectedCalendarWeekData && PATimeControl.Instance.selectedCalendarDay?.length) {
            <td
              class="black_gradient_background"
              style="border: 1px solid black"
              (click)="selectCalendarDay(PATimeControl.Instance.selectedCalendarDay)"
            >
              <span>
                {{ PATimeControl.Instance.weekDayToGermanName(PATimeControl.Instance.selectedCalendarDay, true) }}
                {{
                  PATimeControl.Instance.timestampToDatestring(
                    PATimeControl.Instance.selectedCalendarWeekData.weekdays[PATimeControl.Instance.selectedCalendarDay]
                      .timestamp,
                    false
                  )
                    .split("-")
                    .join(".")
                    .slice(0, 5)
                }}
              </span>
              @for (
                holiday of PATimeControl.Instance.selectedCalendarWeekData.weekdays[
                  PATimeControl.Instance.selectedCalendarDay
                ].holidays;
                track holiday
              ) {
                <span
                  [tooltip]="holiday.tooltip_text"
                  [show-delay]="100"
                  [tooltipClass]="'pa_small_tooltip'"
                  class="holiday_warning"
                >
                  &#8505;
                </span>
              }
            </td>
            <td class="black_background" style="border: 1px solid black; padding: 2px">Fahrt</td>
            <td class="black_background" style="border: 1px solid black; padding: 2px">Aufträge</td>
            <td class="black_background" style="border: 1px solid black; padding: 2px; white-space: nowrap">
              Hawk-Link
            </td>
          }
        </tr>

        @for (technician of preferredTechnicians.concat(shownTechnicians); track technician) {
          @if (shownTechnicians.indexOf(technician) == 0 && showFilteredTechnicians) {
            <tr>
              <td
                style="text-align: center"
                colspan="2"
                class="black_gradient_background"
                (click)="decreaseShowTechnicianIndex()"
              >
                <div style="width: 20px; margin: auto"><div class="rotate">&#10093;</div></div>
              </td>
              @if (
                !PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="(filteredWeekdays.length + 1) * PATimeControl.Instance.shownCalendarWeeksData.length"
                  class="black_background"
                  style="color: white; border: 1px solid black"
                ></td>
              }
              @if (
                PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="filteredWeekdays.length * 2"
                  class="black_background"
                  style="color: white; border: 1px solid black"
                ></td>
              }
              @if (
                PATimeControl.Instance.selectedCalendarWeekData && PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td [attr.colspan]="4" class="black_background" style="color: white; border: 1px solid black"></td>
              }
            </tr>
          }
          @if (
            (shownTechnicians.includes(technician) && showFilteredTechnicians) ||
            (preferredTechnicians.includes(technician) && showPreferredTechnicians)
          ) {
            <tr>
              @if (preferredTechnicians.indexOf(technician) == 0) {
                <td
                  (click)="showPreferredTechnicians = !showPreferredTechnicians"
                  style="text-align: center"
                  class="black_gradient_background"
                  [attr.rowspan]="showPreferredTechnicians ? preferredTechnicians.length : 1"
                >
                  <fa-icon style="color: white" [icon]="faEye"></fa-icon>
                </td>
              }
              @if (shownTechnicians.indexOf(technician) == 0) {
                <td
                  (click)="showFilteredTechnicians = !showFilteredTechnicians"
                  style="text-align: center"
                  class="black_gradient_background"
                  [attr.rowspan]="showFilteredTechnicians ? shownTechnicians.length : 1"
                >
                  <fa-icon style="color: white" [icon]="faEye"></fa-icon>
                </td>
              }
              <td
                style="
                  min-width: 170px;
                  display: flex;
                  flex-direction: row;
                  color: white;
                  height: 28px;
                  border: 1px solid black;
                  position: relative;
                "
                class="black_gradient_background"
                (click)="togglePreferredTechnician(technician)"
              >
                <fa-icon
                  [icon]="faStar"
                  [style.color]="preferredTechnicians.includes(technician) ? 'rgb(0, 127, 211)' : 'gray'"
                  style="margin: auto 2px"
                ></fa-icon>
                <div style="margin: auto 0; font-size: 0.8rem">
                  {{ Util.cutString(technician.lastname + ", " + technician.firstname, 20) }}
                </div>
                @if (
                  technician.country === "deu" && !PATimeControl.Instance.germanStatesTranslations[technician.state]
                ) {
                  <div
                    style="position: absolute; right: 0; top: 50%; transform: translateY(-50%); cursor: pointer"
                    (click)="
                      PATourPlannerControl.Instance.planningAssistantComponent.setStateTechnician = technician;
                      $event.stopPropagation()
                    "
                    tooltip="Solange für diesen Techniker kein Bundesland festgelegt ist, können keine regionalen Feiertage angezeigt werden. Klicken Sie auf das '!'-Symbol, um ein Bundesland auszuwählen!"
                    [tooltipClass]="'pa_small_tooltip body'"
                  >
                    <fa-icon class="text-error fs-5" [icon]="faExclamationSquare"></fa-icon>
                  </div>
                }
              </td>
              @if (
                !PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                @for (calendar_week_data of PATimeControl.Instance.shownCalendarWeeksData; track calendar_week_data) {
                  @for (week_day of filteredWeekdays; track week_day) {
                    @if (
                      technician.getTechnicianDate(calendar_week_data.weekdays[week_day].timestamp, true);
                      as technician_date
                    ) {
                      <td
                        style="border: 1px solid #afafaf; position: relative"
                        (click)="PATourPlannerControl.Instance.planTechnicianDates([technician_date])"
                      >
                        @if (technician_date.loadingStatus === "loaded") {
                          @for (
                            percentages of getTimeFilteredCalendarDataOfTechnicianDate(technician_date)
                              .project_percentages;
                            track percentages
                          ) {
                            <div
                              [style.width]="percentages.percentage + '%'"
                              [style.background-color]="percentages.project ? percentages.project.color : 'white'"
                              [style.border]="percentages.percentage == 100 ? '1px solid black' : 'none'"
                              style="height: 22px; float: left"
                            ></div>
                          }
                        }
                        @if (technician_date.loadingStatus === "init") {
                          <div style="width: 100%; background-color: white; font-size: 0.7rem">Lade Daten...</div>
                        }
                        @if (technician_date.absences.length) {
                          <div
                            style="
                              position: absolute;
                              top: 0;
                              background-color: rgba(109, 0, 0, 0.62);
                              color: white;
                              left: 0;
                              right: 0;
                              bottom: 0;
                              padding: 0 4px;
                              display: inline-flex;
                            "
                          >
                            @for (absence of technician_date.absences; track absence) {
                              <div style="margin: auto; font-size: 0.6rem; line-height: 0.6rem">
                                @if (
                                  PADataControl.Instance.absenceCalendar.reasonMap.get(absence.reasonId);
                                  as reason
                                ) {
                                  {{ reason.name }}
                                }
                              </div>
                            }
                          </div>
                        }
                        @if (
                          !technician_date.absences.length &&
                          !technician_date.getPublicHolidays().length &&
                          technician_date.noShift
                        ) {
                          <div
                            style="
                              position: absolute;
                              top: 0;
                              background-color: rgba(109, 0, 0, 0.62);
                              color: white;
                              left: 0;
                              right: 0;
                              bottom: 0;
                              padding: 0 4px;
                              display: inline-flex;
                            "
                          >
                            <div style="margin: auto; font-size: 0.6rem; line-height: 0.6rem">Keine Schicht</div>
                          </div>
                        }
                        @if (!technician_date.absences.length && technician_date.getPublicHolidays().length) {
                          <div
                            style="
                              position: absolute;
                              top: 0;
                              background-color: rgba(109, 0, 0, 0.62);
                              color: white;
                              left: 0;
                              right: 0;
                              bottom: 0;
                              padding: 0 4px;
                              display: inline-flex;
                            "
                          >
                            <div style="margin: auto; font-size: 0.6rem; line-height: 0.6rem">Feiertag</div>
                          </div>
                        }
                        @if (!technician_date.absences.length && technician_date.getLocalHolidays().length) {
                          <div
                            style="
                              position: absolute;
                              top: 0;
                              background-color: rgba(45, 135, 10, 0.62);
                              color: white;
                              left: 0;
                              right: 0;
                              bottom: 0;
                              padding: 0 4px;
                              display: inline-flex;
                            "
                          >
                            <div style="margin: auto; font-size: 0.6rem; line-height: 0.6rem">
                              Mögl. regio. Feiertag?
                            </div>
                          </div>
                        }
                      </td>
                    }
                  }
                  <td class="black_background white_text" style="padding: 2px; border: 1px solid black">
                    {{ technician.getWeekWorktimeForCalendarWeekData(calendar_week_data) }}
                  </td>
                }
              }
              @if (
                PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                @for (week_day of filteredWeekdays; track week_day) {
                  @if (
                    technician.getTechnicianDate(
                      PATimeControl.Instance.selectedCalendarWeekData.weekdays[week_day].timestamp,
                      true
                    );
                    as technician_date
                  ) {
                    <td style="width: 2000px; padding: 0; position: relative; overflow-y: visible; overflow-x: clip">
                      @if (technician_date.loadingStatus === "loaded") {
                        <hawk-timeline
                          class="horizontal_flex absolute"
                          [tour]="technician_date.tour"
                          [tourIsUpdating]="technician_date.tour.updating"
                          [selected]="false"
                          [showHours]="
                            (shownTechnicians.length &&
                              shownTechnicians.indexOf(technician) == shownTechnicians.length - 1) ||
                            (preferredTechnicians.length &&
                              preferredTechnicians.indexOf(technician) == preferredTechnicians.length - 1)
                          "
                          [showTimeMarker]="false"
                          [showEverySecondHour]="true"
                          [showStatistics]="false"
                          [showOperationIndexes]="false"
                          [timeFilter]="PAFilterControl.Instance.selectedOperationTimeFilter"
                          [chainOperations]="false"
                          [height]="28"
                          (selectTourEvent)="PATourPlannerControl.Instance.planTechnicianDates([technician_date])"
                        >
                        </hawk-timeline>
                      }
                      @if (technician_date.loadingStatus === "init") {
                        <div style="width: 100%; background-color: white; font-size: 0.7rem">Lade Daten...</div>
                      }
                      @if (technician_date.absences.length) {
                        <div
                          style="
                            position: absolute;
                            top: 0;
                            background-color: rgba(109, 0, 0, 0.62);
                            color: white;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            padding: 0 4px;
                            display: inline-flex;
                          "
                        >
                          @for (absence of technician_date.absences; track absence) {
                            <div style="margin: auto; font-size: 0.6rem; line-height: 0.6rem">
                              @if (PADataControl.Instance.absenceCalendar.reasonMap.get(absence.reasonId); as reason) {
                                {{ reason.name }}
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (
                        !technician_date.absences.length &&
                        !technician_date.getPublicHolidays().length &&
                        technician_date.noShift
                      ) {
                        <div
                          style="
                            position: absolute;
                            top: 0;
                            background-color: rgba(109, 0, 0, 0.62);
                            color: white;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            padding: 0 4px;
                            display: inline-flex;
                          "
                        >
                          <div style="margin: auto; font-size: 0.6rem; line-height: 0.6rem">Keine Schicht</div>
                        </div>
                      }
                      @if (!technician_date.absences.length && technician_date.getPublicHolidays().length) {
                        <div
                          style="
                            position: absolute;
                            top: 0;
                            background-color: rgba(109, 0, 0, 0.62);
                            color: white;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            padding: 0 4px;
                            display: inline-flex;
                          "
                        >
                          <div style="margin: auto; font-size: 0.6rem; line-height: 0.6rem">Feiertag</div>
                        </div>
                      }
                      @if (!technician_date.absences.length && technician_date.getLocalHolidays().length) {
                        <div
                          style="
                            position: absolute;
                            top: 0;
                            background-color: rgba(45, 135, 10, 0.62);
                            color: white;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            padding: 0 4px;
                            display: inline-flex;
                          "
                        >
                          <div style="margin: auto; font-size: 0.6rem; line-height: 0.6rem">Mögl. regio. Feiertag?</div>
                        </div>
                      }
                    </td>
                    <td class="black_background" style="border: 1px solid black">
                      {{ technician_date.tour.route.time_specific_data[operationTimeFilter].total_time }}
                    </td>
                  }
                }
              }
              @if (
                PATimeControl.Instance.selectedCalendarWeekData && PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                @if (
                  technician.getTechnicianDate(
                    PATimeControl.Instance.selectedCalendarWeekData.weekdays[PATimeControl.Instance.selectedCalendarDay]
                      .timestamp,
                    true
                  );
                  as technician_date
                ) {
                  <td style="width: 2000px; padding: 0; position: relative; overflow-y: visible; overflow-x: clip">
                    @if (technician_date.loadingStatus === "loaded") {
                      <hawk-timeline
                        class="horizontal_flex absolute"
                        [tour]="technician_date.tour"
                        [tourIsUpdating]="technician_date.tour.updating"
                        [selected]="false"
                        [showHours]="
                          (shownTechnicians.length &&
                            shownTechnicians.indexOf(technician) == shownTechnicians.length - 1) ||
                          (preferredTechnicians.length &&
                            preferredTechnicians.indexOf(technician) == preferredTechnicians.length - 1)
                        "
                        [showTimeMarker]="false"
                        [showStatistics]="false"
                        [showOperationIndexes]="false"
                        [timeFilter]="PAFilterControl.Instance.selectedOperationTimeFilter"
                        [chainOperations]="false"
                        [height]="28"
                        (selectTourEvent)="PATourPlannerControl.Instance.planTechnicianDates([technician_date])"
                      >
                      </hawk-timeline>
                    }
                    @if (technician_date.loadingStatus === "init") {
                      <div style="width: 100%; background-color: white; font-size: 0.7rem">Lade Daten...</div>
                    }
                    @if (technician_date.absences.length) {
                      <div
                        style="
                          position: absolute;
                          top: 0;
                          background-color: rgba(109, 0, 0, 0.62);
                          color: white;
                          left: 0;
                          right: 0;
                          bottom: 0;
                          padding: 0 4px;
                          display: inline-flex;
                        "
                      >
                        @for (absence of technician_date.absences; track absence) {
                          <div style="margin: auto; font-size: 0.6rem; line-height: 0.6rem">
                            @if (PADataControl.Instance.absenceCalendar.reasonMap.get(absence.reasonId); as reason) {
                              {{ reason.name }}
                            }
                          </div>
                        }
                      </div>
                    }
                    @if (
                      !technician_date.absences.length &&
                      !technician_date.getPublicHolidays().length &&
                      technician_date.noShift
                    ) {
                      <div
                        style="
                          position: absolute;
                          top: 0;
                          background-color: rgba(109, 0, 0, 0.62);
                          color: white;
                          left: 0;
                          right: 0;
                          bottom: 0;
                          padding: 0 4px;
                          display: inline-flex;
                        "
                      >
                        <div style="margin: auto; font-size: 0.6rem; line-height: 0.6rem">Keine Schicht</div>
                      </div>
                    }
                    @if (!technician_date.absences.length && technician_date.getPublicHolidays().length) {
                      <div
                        style="
                          position: absolute;
                          top: 0;
                          background-color: rgba(109, 0, 0, 0.62);
                          color: white;
                          left: 0;
                          right: 0;
                          bottom: 0;
                          padding: 0 4px;
                          display: inline-flex;
                        "
                      >
                        <div style="margin: auto; font-size: 0.6rem; line-height: 0.6rem">Feiertag</div>
                      </div>
                    }
                    @if (!technician_date.absences.length && technician_date.getLocalHolidays().length) {
                      <div
                        style="
                          position: absolute;
                          top: 0;
                          background-color: rgba(45, 135, 10, 0.62);
                          color: white;
                          left: 0;
                          right: 0;
                          bottom: 0;
                          padding: 0 4px;
                          display: inline-flex;
                        "
                      >
                        <div style="margin: auto; font-size: 0.6rem; line-height: 0.6rem">Mögl. regio. Feiertag?</div>
                      </div>
                    }
                  </td>
                  <td class="black_background" style="border: 1px solid black">
                    {{ technician_date.tour.route.time_specific_data[operationTimeFilter].driving_time }}min
                  </td>
                  <td class="black_background" style="border: 1px solid black">
                    {{ technician_date.tour.route.time_specific_data[operationTimeFilter].operation_work_time }}min
                  </td>
                  <td class="black_background" style="border: 1px solid black">
                    <a target="_blank" [href]="technician_date.hawk_link">link</a>
                  </td>
                }
              }
            </tr>
          }
          @if (!showPreferredTechnicians && preferredTechnicians.indexOf(technician) == 0) {
            <tr (click)="showPreferredTechnicians = !showPreferredTechnicians">
              @if (preferredTechnicians.indexOf(technician) == 0) {
                <td
                  style="text-align: center"
                  class="black_gradient_background"
                  [attr.rowspan]="showPreferredTechnicians ? preferredTechnicians.length : 1"
                >
                  <fa-icon style="color: white" [icon]="faEyeSlash"></fa-icon>
                </td>
              }
              <td class="black_gradient_background" style="white-space: nowrap">Techniker-Vergleich</td>
              @if (
                !PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="(filteredWeekdays.length + 1) * PATimeControl.Instance.shownCalendarWeeksData.length"
                  class="black_gradient_background"
                  style="color: white; border: 1px solid black"
                ></td>
              }
              @if (
                PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="filteredWeekdays.length * 2"
                  class="black_gradient_background"
                  style="color: white; border: 1px solid black"
                ></td>
              }
              @if (
                PATimeControl.Instance.selectedCalendarWeekData && PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="4"
                  class="black_gradient_background"
                  style="color: white; border: 1px solid black"
                ></td>
              }
            </tr>
          }
          @if (!showFilteredTechnicians && shownTechnicians.indexOf(technician) == 0) {
            <tr (click)="showFilteredTechnicians = !showFilteredTechnicians">
              @if (shownTechnicians.indexOf(technician) == 0) {
                <td
                  style="text-align: center"
                  class="black_gradient_background"
                  [attr.rowspan]="showFilteredTechnicians ? shownTechnicians.length : 1"
                >
                  <fa-icon style="color: white" [icon]="faEyeSlash"></fa-icon>
                </td>
              }
              <td class="black_gradient_background" style="white-space: nowrap">Gefilterte Techniker</td>
              @if (
                !PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="(filteredWeekdays.length + 1) * PATimeControl.Instance.shownCalendarWeeksData.length"
                  class="black_gradient_background"
                  style="color: white; border: 1px solid black"
                ></td>
              }
              @if (
                PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="filteredWeekdays.length * 2"
                  class="black_gradient_background"
                  style="color: white; border: 1px solid black"
                ></td>
              }
              @if (
                PATimeControl.Instance.selectedCalendarWeekData && PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="4"
                  class="black_gradient_background"
                  style="color: white; border: 1px solid black"
                ></td>
              }
            </tr>
          }
          @if (
            shownTechnicians.length &&
            shownTechnicians.indexOf(technician) == shownTechnicians.length - 1 &&
            showFilteredTechnicians
          ) {
            <tr>
              <td
                style="text-align: center"
                colspan="2"
                class="black_gradient_background"
                (click)="increaseShowTechnicianIndex()"
              >
                <div style="width: 20px; margin: auto"><div class="rotate">&#10092;</div></div>
              </td>
              @if (
                !PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="(filteredWeekdays.length + 1) * PATimeControl.Instance.shownCalendarWeeksData.length"
                  class="black_background"
                  style="color: white; border: 1px solid black"
                ></td>
              }
              @if (
                PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="filteredWeekdays.length * 2"
                  class="black_background"
                  style="color: white; border: 1px solid black"
                ></td>
              }
              @if (
                PATimeControl.Instance.selectedCalendarWeekData && PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td [attr.colspan]="4" class="black_background" style="color: white; border: 1px solid black"></td>
              }
            </tr>
          }
          @if (
            preferredTechnicians.length &&
            preferredTechnicians.indexOf(technician) == preferredTechnicians.length - 1 &&
            showPreferredTechnicians &&
            !shownTechnicians.length
          ) {
            <tr>
              @if (
                !PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="
                    (filteredWeekdays.length + 1) * PATimeControl.Instance.shownCalendarWeeksData.length + 4
                  "
                  class="black_background"
                  style="color: white; border: 1px solid black; height: 24px"
                ></td>
              }
              @if (
                PATimeControl.Instance.selectedCalendarWeekData && !PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="filteredWeekdays.length * 2 + 4"
                  class="black_background"
                  style="color: white; border: 1px solid black; height: 24px"
                ></td>
              }
              @if (
                PATimeControl.Instance.selectedCalendarWeekData && PATimeControl.Instance.selectedCalendarDay?.length
              ) {
                <td
                  [attr.colspan]="8"
                  class="black_background"
                  style="color: white; border: 1px solid black; height: 24px"
                ></td>
              }
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>
